<template>
  <div class="add-vacc">
    <common-head title="添加疫苗" />
    <van-empty image="search" description="暂无数据" v-if="!list.length" />
    <div class="my-wrap" v-else>
      <div class="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{current: index == n}"
        >
          <div class="item" @click="change(index)">
            <b :class="{disabled: !item.hasStock}">{{ item.vaccineSupName }}</b>
            <van-tag plain v-if="!item.hasStock">无库存</van-tag>
          </div>
          <div class="mask" v-if="!item.hasStock"></div>
        </div>
      </div>
      <p>注：根据添加的受种者年龄及国家免疫规划接种政策要求，推荐您为所选受种者接种以上几类疫苗。</p>
    </div>
    <!-- 选择疫苗小类 -->
    <action-sheet ref="action" />
    <!-- <div class="my-button">
      <van-button 
        type="info" 
        round
        :disabled="disabled"
        @click="showAction"
      >
        下一步
      </van-button>
    </div> -->
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import ActionSheet from './ActionSheet'
import { fetchAdultVacc, fetchChildVacc, fetchVariuosVacc, fetchVacc } from 'api/vacc'

export default {
  components: {
    CommonHead,
    ActionSheet
  },
  computed: {
    key() {
      return this.$store.state.key
    },
    povCode() {
      return this.$route.query.povCode
    },
    profileCode() {
      return this.$route.query.profileCode
    }
  },
  data() {
    return {
      n: -1,
      list: [],
      vaccineSupId: '',
      disabled: true,
    }
  },
  created() {
    this.getVacc()
  },
  methods: {
    // 获取疫苗大类
    getVacc() {
      let params = {
        povCode: this.povCode,
        profileCode: this.profileCode
      }
      if (this.key == 'children') {
        fetchChildVacc(params).then(res => {
          this.handleVaccData(res)
        })
      } else if (this.key == 'adult') {
        fetchAdultVacc(params).then(res => {
          this.handleVaccData(res)
        })
      } else {
        switch (this.key) {
          case 'rabies':
            params.type = 1
            break;
          case 'flu':
            params.type = 2
            break;
          case 'xg':
            params.type = 3
            break;
        }
        fetchVariuosVacc(params).then(res => {
          this.handleVaccData(res)
        })
      }
    },
    handleVaccData(res) {
      this.list = res.data
      // 按钮禁用处理
      // const sign = this.list.some(v => v.hasStock)
      // if (sign) {
      //   this.disabled = false
      // } else {
      //   this.disabled = true
      // }
    },
    // 弹出面板
    showAction() {
      const params = {
        povCode: this.povCode,
        profileCode: this.profileCode,
        vaccineSupId: this.vaccineSupId
      }
      fetchVacc(params).then(res => {
        this.$refs.action.open(res.data)
      })
    },
    // 选中
    change(index) {
      // if (this.n == index) return
      this.n = index
      this.vaccineSupId = this.list[index].vaccineSupId
      if (this.n == -1) {
        return this.$toast('请选择疫苗种类')
      }
      this.showAction()
    }
  }
}
</script>

<style lang="less" scoped>
.add-vacc {
  padding-bottom: 81px;
  .list {
    >div {
      border: 1px solid #ddd;
      border-radius: 5px;
      margin-bottom: 11px;
      position: relative;
      .item {
        height: 42px;
        background: #fff;
        border-radius: 5px;
        padding: 0 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        b {
          opacity: .85;
          margin-right: 7px;
        }
        .disabled {
          color: #999;
        }
        .van-tag {
          border-color: #999;
          color: #999;
          background: #fff;
        }
      }
      .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        background: rgba(0,0,0,.05);
      }
    }
    .current {
      border-color: var(--blue);
    }
  }
  p {
    font-size: 12px;
    color: #999;
    font-weight: 400;
    opacity: .85;
  }
}
</style>